import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import TPTypography from 'components/TP-UI/TPTypography';
import { isCyHub } from '../../helpers/hubs';
import Informer from 'modules/common/Informer';

const AuthInformer = ({ hub }) => {
  const cyHub = isCyHub(hub);

  return cyHub ? (
    <Informer>
      <TPTypography variant="body1">
        <Trans i18nKey="riskWarningCySec" ns="auth">
          CFDs are complex instruments and come with a high risk of losing money rapidly due to
          leverage.
          <TPTypography component="span" variant="body1" bold>
            The vast majority of retail client accounts lose money when trading in CFDs.
          </TPTypography>
          You should consider whether you understand how CFDs work and whether you can afford to
          take the high risk of losing your money.
        </Trans>
      </TPTypography>
    </Informer>
  ) : null;
};

AuthInformer.propTypes = {
  hub: PropTypes.string,
};

export default AuthInformer;
